import * as React from "react";
import { useStaticQuery, graphql } from "gatsby";

interface SeoProps {
	description: string;
	title: string;
	noindex?: boolean;
	children?: React.ReactNode;
}

function Seo({ description, title, noindex, children }: SeoProps) {
	const { site } = useStaticQuery(
		graphql`
			query SeoQuery {
				site {
					siteMetadata {
						title
						description
					}
				}
			}
		`
	);

	const metaDescription = description || site.siteMetadata.description;
	const defaultTitle = site.siteMetadata?.title;

	return (
		<>
			<title>{title ? title : defaultTitle}</title>
			<meta name="description" content={metaDescription} />
			<meta property="og:title" content={title} />
			<meta property="og:description" content={metaDescription} />
			<meta property="og:type" content="website" />
			<meta name="twitter:card" content="summary" />
			<meta name="twitter:creator" content={site.siteMetadata?.author || ``} />
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={metaDescription} />
			<meta name="robots" content={noindex ? "noindex,nofollow" : ""} />
			<meta
				name="google-site-verification"
				content="EnIxGAJQLnG0unNC6Kb43nxr823Bl47QU0e-ml8IR7c"
			/>
			{children}
		</>
	);
}

export default Seo;
